import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ButtonDanger from "../../common/buttonDanger";
import ButtonIcon from "../../common/buttonIcon";
import ButtonSubmit from "../../common/buttonSubmit";
import Moment from 'react-moment';
import AlertMessageModal from "../../alertMessageModal"
import { useEffect, useState } from "react";
import moment from "moment"
import EditTimeslot from "./editTimeslot";
import RepeatTimeslot from "./repeatTimeslot";
import SuccessMessageBox from "../../common/successMessageBox";
import { useAppDispatch } from "../../../redux";
import { deleteTimeslotById, forceTimeslotUpdate } from "../../../redux/reducer/timeslotReducer";
import AlertMessage from "../../alertMessage";
import InfoMessage from "../../infoMessage";
import { HttpService } from "../../../services/HttpService";
import BoxPrenotationLinks from "../../boxPrenotationLinks";
import { hasAlphaFeaturesEnabled, hasModules, isGroupLinkActive, isGroupLinkChild, isGroupLinkParent } from "../../../utils/helpers";
import SuccessAlertMessage from "../../alertMessageModal/SuccessAlertMessage";

const ViewTimeslot = (props: any) => {
  const { t } = useTranslation();
  const { eventId, user } = useSelector((state: any) => state.login);
  const alphaFeaturesEnabled = hasAlphaFeaturesEnabled(user)
  const { timeslotDetailUpdate } = useSelector((state: any) => state.timeslot);

  let idEvent = props.idEvent ?? "";
  const [modalDelete, setmodalDelete] = useState(false);
  const dispacth = useAppDispatch();
  const [event, setEvent] = useState<any>(null);
  const [doctorTimeslotSuccess, setDoctorTimeslotSuccess] = useState<any>('');
  const [doctorTimeslotError, setDoctorTimeslotError] = useState<any>('');
  const [showPopUpManager, setShowPopUpManager] = useState("");
  const [prenotations, setPrenotations] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [service, setService] = useState<any>({})
  let obbjectTranslate = {
    time: moment(event?.start).format("ll HH:mm") + " - " + moment(event?.end).format("HH:mm"),
    service: service?.name
  }
  const deleteTimeslot = async () => {
    const result = await dispacth(deleteTimeslotById(idEvent));
    if (result.status === 200) {
      props.closePopUp();
      setmodalDelete(false)
      dispacth(forceTimeslotUpdate())
    }
    else {
      setErrorMessage(result.data?.error ?? t('error.generic'));
      console.log("Data Error", result.data?.error);
    }
    ;
  }


  const [successMessage, setSuccessMessage] = useState("");

  const loadBookings = async () => {
    let result: any = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/event/${event?.event}/timeslot/${idEvent}/bookings`);
    setPrenotations(result.data)
  }

  useEffect(() => {
    if (event?.event) {
      loadBookings()
    }
  }, [event, timeslotDetailUpdate])

  const changeMessagesuccess = (message: string) => {
    setSuccessMessage(message);
    setTimeout(() => (setSuccessMessage("")), 2000)
  }

  const getTimeForTimeSlotId = (event: any) => {
    return `${moment(event.startDate).utc().format('[T]HH:mm:ss.SSS[Z]')}${moment(event.endDate).utc().format('[T]HH:mm:ss.SSS[Z]')}`
  }

  const clickPrenotationLink = (bookingId: string) => {
    const selectTimeslotId = hasModules(user,'FEDERFARMA_DOCTOR') ? getTimeForTimeSlotId(event) : event._id
    props.clickPrenotationLink(
      moment(new Date(event.startDate)).format('YYYY-MM-DD'),
      selectTimeslotId, // timeslot ID
      bookingId
    )
  }

  const fetchData = async () => {
    let timeslot;
    let endPoint=`t4event/api/v01/event/${eventId}/timeslot/${idEvent}`
    if(hasModules(user,'FEDERFARMA_DOCTOR')){
      endPoint=`t4event/api/v01/federfarma/doctor/timeslot/${idEvent}`
    }
    const timeslotResult = await HttpService.get(`${process.env.REACT_APP_API}/${endPoint}`);
    if (timeslotResult.status === 200) {
      timeslot = timeslotResult.data
      timeslot.start = new Date(timeslot.startDate)
      timeslot.end = new Date(timeslot.endDate)
      setEvent(timeslot)
    }
    const timeslotCategoryResult = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/event/${timeslot?.event}/timeslot-category/${timeslot.category}`);
    if (timeslotCategoryResult.status === 200) {
      const timeslotCategory = timeslotCategoryResult.data
      setService(timeslotCategory)
    }
  }


  const assignDoctorTimeslot = async () => {
    try{
      const assignDoctor = await HttpService.post(`${process.env.REACT_APP_API}/t4event/api/v01/federfarma/doctor/timeslot/${idEvent}/assign`, {});
      fetchData() // refetch data after api success
      setDoctorTimeslotSuccess(assignDoctor?.data?.result?.message)
    }catch(e: any){
      setDoctorTimeslotError(e?.response?.data?.result?.key)
      console.log("Data Error", e?.response?.data?.result?.key);
    }
  }

  const unAssignDoctorTimeslot = async () => {
    try{
      await HttpService.post(`${process.env.REACT_APP_API}/t4event/api/v01/federfarma/doctor/timeslot/${idEvent}/unassign`, {});
      fetchData() // refetch data after api success
      setDoctorTimeslotSuccess('TIMESLOT_NOT_ASSIGNED')
    }catch(e: any){
      setDoctorTimeslotError(e?.response?.data?.result?.key)
      console.log("Data Error", e?.response?.data?.result?.key);
    }
  }

  const createBookingForCitizen = async (eventId:string) => {
    const guestApp = await HttpService.post(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/guestappTokens`, {});
    const { eventHash, token } = guestApp.data.guestappToken;
    const result = await HttpService.post(`${process.env.REACT_APP_API}/t4event/api/v01/public/timeslot/event/${eventHash}/${idEvent}`, { "numberAttendaces": 1 });
    const { bookingId } = result.data;
    const handleMessage = async (event: any) => {

      if (event.data === 'CLOSE_WINDOW') {
        await fetchData()
        window.removeEventListener('message', handleMessage);
      }
    };
    window.addEventListener('message', handleMessage);

    window.open(process.env.REACT_APP_GUESTAPP + `/calendar/event/${eventHash}/prenotation?bookingId=${bookingId}&token=${token}`);
  }

  // fetch data
  useEffect(() => {
    fetchData()
    setShowPopUpManager("")
  }, [idEvent, timeslotDetailUpdate])

  const isTimeslotClosed = event && moment().isAfter(moment(event.startDateBeforeClosing))
  const timeslotClosedButtonTitle = isTimeslotClosed ? t('timeslot.timeslot-closed') : ""

  return (
    ((event) ?
      <>
        <div className="ViewTimeslot">
          <div className="header">
            <div className="row ">
              <div className="col-10">
                <h6><b><Moment format="LL">{event?.start}</Moment>  </b></h6>
                <h6><Moment format="HH:mm">{event?.start}</Moment> - <Moment format="HH:mm">{event?.end}</Moment></h6>
              </div>
              <div className="col-2 text-right">
                <ButtonIcon handleClick={(e: any) => { props.closePopUp(e); setDoctorTimeslotError("") }} icon="close" />
              </div>
            </div>
          </div>
          <div className="body">
            <div className="bodySection">
              <h5 className="service"><b>{t('service')}</b> {service?.name}</h5>
              {isGroupLinkActive(service.groupLink) &&
                <InfoMessage description={t('timeslot.linked-message')} additionalClass="mt-1" />
              }

            </div>
            <div className="bodySection">
              <h5 className="service"><b>{t('notification-email')}</b></h5>
              {((service?.emails?.length) ?
                <>
                  <ul className="emailList">
                    {(service?.emails.map((email: any, index: number) => (
                      <li key={index}>{email}</li>
                    )))}
                  </ul>
                  <InfoMessage description={t('info-timeslot')} additionalClass="mt-1" />
                </>
                :
                <p className="service">{t('no-email')}</p>
              )}

            {hasModules(user,'FEDERFARMA_DOCTOR') &&
                <h5 className="service"><b>{t('prenotation.farmacia')}</b>: {event?.eventName}</h5>
              }

              {event?.assignedDoctorFullName &&
                <h5 className="service"><b>{t('prenotation.doctor')}</b>: {event?.assignedDoctorFullName}</h5>
              }

            </div>
            <div className="bodySection seats">
              <p className="service m-0"><b>{t('seats')}:</b> {event.maximumAttendances - event.savedAttendances}</p>
              <p className="service m-0">
                <b>{t('reserved-seats')}:</b>
                &nbsp;{event.savedAttendances}
                {isGroupLinkActive(service.groupLink) &&
                  <>
                    &nbsp;<span
                      className="material-icons"
                      title={t('timeslot.linked-seats-message')}
                    >
                      help
                    </span>
                  </>
                }
              </p>
            </div>

            <SuccessMessageBox successMessage={successMessage} />

          { doctorTimeslotError && 
              <div className="col-lg-12 p-2">
                <AlertMessage description={t('error.' + doctorTimeslotError)} additionalClass="mt-2" />
              </div>
            }

          { doctorTimeslotSuccess && 
              <AlertMessageModal
                show={true}
                description={t('error.' + doctorTimeslotSuccess)}
              closeModal={()=>setDoctorTimeslotSuccess('')}
              />
            }

          </div>

          {((!event?.deleted) ?
            <div className="footer">
              <div className="row">
                {/* If uncomment code view a button to repeat time slot */}
                {/* <div className="col-lg-6 p-2">
                  <ButtonWhite handleChange={() => (setShowPopUpManager("Repeat"))} textButton="Ripeti fascia" />
                </div> */}
                {
                  !hasModules(user,'FEDERFARMA_DOCTOR') &&
                  (!service.telemedicine || alphaFeaturesEnabled) &&
                  <>
                    <div className="col-lg-6 p-2" title={isGroupLinkChild(service.groupLink) ? t("timeslot.linked-child-edit-title") : ""}>
                      <ButtonSubmit
                        disabled={service.disabled || isGroupLinkChild(service.groupLink)}
                        handleChange={() => (setShowPopUpManager("Edit"))}
                        textButton="Modifica fascia"
                      />
                    </div>
                    <div className="col-lg-6 p-2" title={isGroupLinkChild(service.groupLink) ? t("timeslot.linked-child-delete-title") : ""}>
                      <ButtonDanger
                        disabled={service.disabled || isGroupLinkChild(service.groupLink)}
                        textButton="Elimina fascia"
                        handleChange={() => (setmodalDelete(true), setErrorMessage(""))}
                      />
                    </div>
                  </>
                }

                { hasModules(user,'FEDERFARMA_DOCTOR') && 
                  <>
                    {
                      event?.assignedDoctor === null &&
                      alphaFeaturesEnabled &&
                      <div className="col-lg-12 p-1" title={timeslotClosedButtonTitle}>
                        <ButtonSubmit
                          disabled={isTimeslotClosed}
                          handleChange={assignDoctorTimeslot}
                          textButton={t('add-availability')}
                        />
                      </div>
                    }
                    {
                      event?.assignedDoctor && !event?.savedAttendances &&
                      alphaFeaturesEnabled &&
                      <div className="col-lg-12 p-1" title={timeslotClosedButtonTitle}>
                        <ButtonDanger
                          disabled={isTimeslotClosed}
                          handleChange={unAssignDoctorTimeslot}
                          textButton={t('delete-availability')}
                        />
                      </div>
                    }
                    {
                      event?.assignedDoctor && !event?.savedAttendances &&
                      <div className="col-lg-12 p-1" title={timeslotClosedButtonTitle}>
                        <ButtonSubmit
                          disabled={isTimeslotClosed}
                          handleChange={()=>createBookingForCitizen(event?.event)}
                          textButton={t('prenotation.book-for-citizen')}
                        />
                      </div>
                    }
                  </>

                }

                {(service.disabled ?
                  <div className="col-lg-12 p-2">
                    <AlertMessage description={t('service-disabled-timeslot-description')}
                      additionalClass="mt-4" />
                  </div>
                  :
                  <></>
                )}
                {(event.savedAttendances > 0 ?
                  <div className="col-lg-12 p-2">
                    <AlertMessage description={t('danger-timeslot-delete')}
                      additionalClass="mt-2" />
                  </div>
                  :
                  <></>
                )}
              </div>
            </div>
            :
            <></>
          )}

          <BoxPrenotationLinks
            clickPrenotationLink={clickPrenotationLink}
            prenotations={prenotations}
            hasReservation={event?.savedAttendances}
            timeslot={event}
          />

        </div>
        <EditTimeslot
          changeMessagesuccess={changeMessagesuccess}
          closePopUp={() => (setShowPopUpManager(""))}
          showPopUpManager={showPopUpManager}
          event={event}
          onSave={fetchData}
          isParent={isGroupLinkParent(service.groupLink)}
        />
        <RepeatTimeslot changeMessagesuccess={changeMessagesuccess} closePopUp={() => (setShowPopUpManager(""))} showPopUpManager={showPopUpManager} idEvent={idEvent} />
        <AlertMessageModal
          title={t('delete')}
          description={<p>{t('popup-timeslot.delete-timeslot', obbjectTranslate) as string}</p>}
          closeModal={() => (setmodalDelete(false))}
          titleButtonSecondary={t('popup-timeslot.button-cancel')}
          handleClosePrimary={() => { deleteTimeslot() }}
          titleButtonPrimary={t('popup-timeslot.button-delete')}
          handleCloseSecondary={() => (setmodalDelete(false))}
          alertMessage={isGroupLinkParent(service.groupLink) ? t('timeslot.linked-parent-delete-message') : ''}
          errorMessage={errorMessage}
          show={modalDelete} />
      </>
      :
      <></>))
}
export default ViewTimeslot